'use strict';

// Class definition
var KTTablesWidget5 = (function () {
  var table;
  var datatable;

  // Private methods
  const initDatatable = () => {
    // Set date data order
    const tableRows = table.querySelectorAll('tbody tr');

    tableRows.forEach((row) => {
      const dateRow = row.querySelectorAll('td');
      const realDate = moment(dateRow[2].innerHTML, 'MMM DD, YYYY').format(); // select date from 3rd column in table
      dateRow[2].setAttribute('data-order', realDate);
    });

    // Init datatable --- more info on datatables: https://datatables.net/manual/
    datatable = $(table).DataTable({
      info: false,
      order: [],
      lengthChange: false,
      pageLength: 6,
      paging: false,
      columnDefs: [
        { orderable: false, targets: 1 }, // Disable ordering on column 1 (product id)
      ],
    });
  };

  // Handle status filter
  const handleStatusFilter = () => {
    const select = document.querySelector(
      '[data-kt-table-widget-5="filter_status"]',
    );

    $(select).on('select2:select', function (e) {
      const value = $(this).val();
      if (value === 'Show All') {
        datatable.search('').draw();
      } else {
        datatable.search(value).draw();
      }
    });
  };

  // Public methods
  return {
    init: function () {
      table = document.querySelector('#kt_table_widget_5_table');

      if (!table) {
        return;
      }

      initDatatable();
      handleStatusFilter();
    },
  };
})();

// Webpack support
if (typeof module !== 'undefined') {
  module.exports = KTTablesWidget5;
}

// On document ready
KTUtil.onDOMContentLoaded(function () {
  KTTablesWidget5.init();
});
